exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-secondary-custom[data-v-433a78ce],\n.btn-secondary-custom[data-v-433a78ce]:hover {\n  color: black;\n  background-color: #ebebeb;\n  border-color: #dedcdc;\n  line-height: 0;\n  border-radius: 5px;\n}\n", ""]);

// exports
